'use client';
import type { ReactElement } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BackButton } from '../../common-buttons/BackButton';
import { NavbarProfileAction } from './NavbarProfileAction';
interface LoggedNavbarRightActionProps {
    authError: boolean;
    isMobile: boolean;
    isUserMenuModalOpen: boolean;
    onModalClose: () => void;
    onProfileClick: () => void;
    profileImageSrc?: string;
}
export function LoggedNavbarRightAction({ authError, isMobile, isUserMenuModalOpen, onModalClose, onProfileClick, profileImageSrc, }: LoggedNavbarRightActionProps): ReactElement {
    return (
      <AnimatePresence mode="wait" initial={false}>
        {isUserMenuModalOpen ? (<motion.div key="back-button-right" initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }} transition={{ duration: 0.1, ease: [0.4, 0, 0.2, 1] }}>
            <BackButton onClick={onModalClose}/>
          </motion.div>) : (<motion.div key="profile-button" initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.8 }} transition={{ duration: 0.1, ease: [0.4, 0, 0.2, 1] }}>
            <NavbarProfileAction authError={authError} isMobile={isMobile} onProfileClick={onProfileClick} profileImageSrc={profileImageSrc}/>
          </motion.div>)}
      </AnimatePresence>
    );
}
